import React, { useState, useEffect } from "react";
import 'react-querybuilder/dist/query-builder.css';
import "./siteUrl.css";
import {
  Button,
  Card,
  CardBody,
  Col,
  Row,
} from "reactstrap";
import { connect } from "react-redux";
import { setBreadcrumbItems } from "../../store/actions";
import { MDBDataTable } from "mdbreact";
import {
  BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer, CartesianGrid,
  PieChart, Pie
} from 'recharts';
import axiosInstance from "components/Common/ApiManagement/axiosInstance";
import { ApiNames } from "components/Common/ApiManagement/apiServices";
import { useNavigate, useParams } from "react-router-dom";
import { PAGEPATHS } from "components/Common/Constant";

const IndividualReports = props => {
  const { scanId, reportName, scanName } = useParams();
  const navigate = useNavigate();
  const reportTitle = reportName.replace(/_/g, " ");

  const [data, setData] = useState([]);
  const [viewTypes, setviewTypes] = useState([0]); // default to table view
  const [individualData, setIndividualData] = useState({
    direct: { columns: [], rows: [] },
    indirect: { columns: [], rows: [] },
  });
console.log(viewTypes,"viewTypesviewTypes")
  document.title = "Add Site URL's";

  useEffect(() => {
    props.setBreadcrumbItems("Compliance Page", []);
    getComplianceData();
  }, []);

  const getComplianceData = async () => {
    try {
      const response = await axiosInstance.post(ApiNames.COMPLIANCE_TABLE_LIST, {
        area: reportTitle,
        scanId: scanId,
        scanname: scanName
      });

      const resData = response.data.data || {};
      const allData = resData.data || [];
      setData(allData);
      setviewTypes(resData.viewTypes ?? [0]);

      const directData = allData.filter(item => item.isDirect);
      const indirectData = allData.filter(item => !item.isDirect);

      const columns = [
        { label: 'Table Name', field: 'tableName', sort: 'asc' },
        { label: 'Field Name', field: 'fieldName', sort: 'asc' },
        { label: 'Value', field: 'value', sort: 'asc' },
      ];

      const formatRow = item => ({
        tableName: item.tableName,
        fieldName: item.fieldName,
        value:
          typeof item.value === 'object' && item.value !== null
            ? Object.entries(item.value)
                .map(([k, v]) => `${k}: ${String(v)}`)
                .join('\n')
            : String(item.value),
      });

      setIndividualData({
        direct: { columns, rows: directData.map(formatRow) },
        indirect: { columns, rows: indirectData.map(formatRow) },
      });
    } catch (e) {
      console.error("Error fetching compliance data:", e);
    }
  };

  const prepareChartData = (data = []) =>
    data.map(item => ({
      fieldName: item.fieldName,
      valueCount:
        typeof item.value === 'object' && item.value !== null
          ? Object.keys(item.value).length
          : 1,
    }));

  const renderTableView = () => (
    <>
      <h5 className="mb-3">🔵 Direct Relationship</h5>
      <MDBDataTable responsive striped data={individualData.direct} />

      <h5 className="mt-5 mb-3">🟠 Indirect Relationship</h5>
      <MDBDataTable responsive striped data={individualData.indirect} />
    </>
  );

  const renderCardView = () => (
    <div className="grid-container">
      {data.map((item, index) => (
        <Card
          className={`grid-item ${item.value === 200 ? 'bg-success' : 'bg-danger'} text-white`}
          key={index}
        >
          <CardBody>
            <p><strong>Field Name:</strong> {item.fieldName}</p>

            {/* Handle primitive or object value */}
            <div>
              <strong>Value:</strong>
              {typeof item.value === 'object' && item.value !== null ? (
                <ul style={{ paddingLeft: '1rem' }}>
                  {Object.entries(item.value).map(([key, val], idx) => (
                    <li key={idx}><strong>{key}:</strong> {String(val)}</li>
                  ))}
                </ul>
              ) : (
                <span> {item.values}</span>
              )}
            </div>

            <p><strong>Category:</strong> {item.category}</p>
            <p><strong>Scan Title:</strong> {item.scanTitle}</p>
            <p><strong>Scan Group:</strong> {item.scanGroup}</p>
            <p><strong>Scan Subcategory:</strong> {item.scanSubcat}</p>
            <p><strong>Relationship:</strong> {item.isDirect ? 'Direct' : 'Indirect'}</p>
            <p><strong>Description:</strong> {item.auditDesc}</p>
          </CardBody>
        </Card>
      ))}
    </div>
  );

  const renderChartView = () => (
    <>
      <div style={{ width: '100%', height: 300 }}>
        <h5 className="text-center">Bar Chart</h5>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={prepareChartData(data)}
            margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="fieldName" />
            <YAxis allowDecimals={false} />
            <Tooltip />
            <Legend />
            <Bar dataKey="valueCount" fill="#8884d8" name="Field Count" />
          </BarChart>
        </ResponsiveContainer>
      </div>

      <div style={{ width: '100%', height: 300, marginTop: 50 }}>
        <h5 className="text-center">Pie Chart</h5>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={prepareChartData(data)}
              dataKey="valueCount"
              nameKey="fieldName"
              cx="50%"
              cy="50%"
              outerRadius={100}
              fill="#82ca9d"
              label
            />
            <Tooltip />
            <Legend />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </>
  );

  return (
    <React.Fragment>
      <Row className="justify-content-center">
        <Col lg={12}>
          <Card>
            <div className="d-flex justify-content-between p-3">
              <h2>{reportTitle} - {scanName}</h2>
              <Button color="secondary" onClick={() => navigate(`${PAGEPATHS.ComplianceDashboard}/${scanId}/${reportName}`)}>Back</Button>
            </div>
           <CardBody>
  {viewTypes.includes(0) && renderTableView()}
  {viewTypes.includes(1) && renderCardView()}
  {viewTypes.includes(2) && renderChartView()}
</CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default connect(null, { setBreadcrumbItems })(IndividualReports);
